import { BankAccount } from '@/types/bankAccount';

const NICKNAME_MAX_LENGTH = 20;

export const formatBankAccountTitle = (bankAccount: BankAccount) => {
    const nickName =
        bankAccount.nickName.length > NICKNAME_MAX_LENGTH
            ? `${bankAccount.nickName.substring(0, NICKNAME_MAX_LENGTH)}...`
            : bankAccount.nickName;

    return `${nickName} ****${bankAccount.accountNumberSuffix}`;
};
